import { IUpdateDriverDto } from './create-driver-dto.interface';
import { ITachographInputDto } from './tachograph-input-dto.interface';

export interface IBulkUpdateDriversInputDto {
    drivers: (IUpdateDriverDto & {
        id: string;
        tachograph?: ITachographInputDto;
    })[];
}
